import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {URLListComponent} from '@webmate-web-core/shared/components/urls/urllist.component';
import { SequentialComponent } from './sequential.component';
import { ClickDriverComponent } from './click-driver.component';
import {URLPairsComponent} from '@webmate-web-core/shared/components/urls/urlpairs.component';
import {BasicAuthComponent} from '@webmate-web-core/shared/components/urls/basic-auth.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [
        URLListComponent,
        SequentialComponent,
        ClickDriverComponent,
        URLPairsComponent,
        BasicAuthComponent
    ],
    imports: [
        CommonModule,
        FontAwesomeModule,
    ],
    exports: [
        URLListComponent,
        SequentialComponent,
        URLPairsComponent,
        ClickDriverComponent,
        BasicAuthComponent
    ]
})
export class URLModule {}
